module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Usb-storage-2118c2260ed125254f6b668c0ae369eb.svg";